<template>
  <div style="background-color: #fff;" class="w-100 h-100">
    <div v-show="!warning">
      <div
        style="display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #eeeeee;padding: 14px 20px">
        <div style="font-size: 18px;font-weight: bold">{{ $t('protocol.title') }}</div>
        <a-space>
          <a-button v-if="authorities.find(a => a.code === 'device:manage:device:protocol:sync')" type="primary"
            @click="refresh">{{ $t('protocol.sync') }}</a-button>
          <a-button key="submit" type="primary" @click="addProtocol">{{ isEdit ? $t('common.update') : $t('buttons.add')
            }}</a-button>
          <a-button type="primary" @click="exportProtocolToExcel">{{ $t("buttons.export") }}</a-button>
          <a-button key="submit" @click="goBack">{{ $t('buttons.goBack') }}</a-button>
        </a-space>
      </div>
      <div>
        <div style="border-bottom: 1px solid #eeeeee;padding: 20px">
          <a-form-model :key="protocolForm.driver" ref="pForm" :model="protocolForm" :rules="rules" labelAlign="right"
            layout="inline" :labelCol="{ span: 9 }" :wrapperCol="{ span: 15 }">
            <a-row :gutter="16">
              <a-col :span="protocolFormSpan">
                <a-form-model-item style="width: 100%" :label="$t('common.driverType')" prop="driver">
                  <a-select :value="protocolForm.driver" style="width: 100%" @change="changeDriver" :disabled="isEdit">
                    <a-select-option value="MODBUS_RTU">MODBUS_RTU</a-select-option>
                    <a-select-option value="DLT645_2007">DLT645_2007</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="protocolFormSpan" v-for="(item, index) in driver.protocolProperty" :key="index">
                <a-form-model-item class="w-100" :label="item[lang]" :prop="item.value">
                  <a-input class="w-100" v-if="item.type === 'text'" v-model="protocolForm[item.value]"
                    @change="change(item.value)" :disabled="isEdit && item.value === 'code'" />
                  <a-input-number class="w-100" v-if="item.type === 'number'" v-model="protocolForm[item.value]" />
                  <a-select class="w-100" v-if="item.type === 'select'" v-model="protocolForm[item.value]">
                    <a-select-option v-for="(option, index) in item.options" :defaultValue="item.options[0].value"
                      :key="index" :value="option.value">{{ option[lang] }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="protocolFormSpan">
                <a-form-model-item class="w-100" :label="$t('protocol.ignoreCode')" :extra="$t('protocol.ignoreInfo')">
                  <a-select v-model="protocolForm.ignoreCode">
                    <a-select-option value="">{{ $t('common.none') }}</a-select-option>
                    <a-select-option v-for="point in protocolForm.points" :key="point.code" :value="point.code">{{
                      point.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="17">
                <a-form-model-item :labelCol="{ span: lang === 'en' ? 3 : 2 }"
                  :wrapperCol="{ span: lang === 'en' ? 21 : 22 }" class="w-100" :label="$t('protocol.warningTemplate')"
                  style="padding-left: 52px;">
                  <a-select disabled mode="tags" v-model="protocolForm.warningTemplateId">
                    <a-select-option v-for="point in warningTemplateList" :key="point.id" :value="point.id + ''">{{
                      point.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="1">
                <a-button type="primary" style="margin-top: 5px" @click="isPointsShow = false">{{ $t('buttons.edit')
                  }}</a-button>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <template v-if="isPointsShow">
          <div style="padding: 14px 20px;display: flex;justify-content: space-between;align-items: center">
            <div style="font-size: 18px;font-weight: bold">{{ $t('modification.points') }}</div>
            <a-button type="primary" @click="addDataPoints" :disabled="!protocolForm.driver">{{ $t('protocol.addPoint')
              }}</a-button>
          </div>
          <div style="padding: 0 10px">
            <el-table v-show="protocolForm.driver" v-loading="loading" style="width: 100%" max-height="500px"
              :data="points" :header-cell-style="{ backgroundColor: '#fafafa' }" :row-key="row => row.id">
              <el-table-column v-for="(col, index) in driver.dataPointColumns" :key="index" :prop="col.dataIndex"
                :label="col.title" :width="col.width" :sortable="col.sortable">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left; display: inline-flex">
                    {{ col[lang] }}
                    <!-- <span class="icons unset" style="cursor: pointer;" data-index="0">
                      <a-icon type="caret-up" />
                      <a-icon type="caret-down" />
                    </span> -->
                  </div>
                  <a-input @click.stop v-if="col.input" v-model="queryParams[col.dataIndex]"
                    @keyup.enter="searchPoints" />
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.editable">
                    <div v-if="col.dataIndex === 'statisticType'" class="ant-form-item-control"
                      :class="{ 'has-error': errorOptions[scope.$index].statisticType }" style="">
                      <a-select class="w-100" :class="{ 'has-error': errorOptions[scope.$index].statisticType }"
                        :default-value="scope.row[col.dataIndex]"
                        @blur="validate('statisticType', scope.row, scope.$index)"
                        @change="(value) => scope.row[col.dataIndex] = value">
                        <a-select-option value="0">{{ $t('protocol.sum') }}</a-select-option>
                        <a-select-option value="1">{{ $t('protocol.fluctuation') }}</a-select-option>
                      </a-select>
                      <div class="ant-form-explain" v-show="errorOptions[scope.$index].statisticType">{{
                        $t('protocol.sst') }}</div>
                    </div>
                    <div v-else-if="col.dataIndex === 'codecType'" class="ant-form-item-control"
                      :class="{ 'has-error': errorOptions[scope.$index].codecType }" style="">
                      <a-select class="w-100" :class="{ 'has-error': errorOptions[scope.$index].codecType }"
                        :default-value="scope.row[col.dataIndex]" @blur="validate('codecType', scope.row, scope.$index)"
                        @change="(value) => scope.row[col.dataIndex] = value">
                        <a-select-option value="HEX">HEX</a-select-option>
                        <a-select-option value="BCD">BCD</a-select-option>
                      </a-select>
                      <div class="ant-form-explain" v-show="errorOptions[scope.$index].codecType">{{ $t('protocol.sct')
                        }}</div>
                    </div>
                    <div v-else-if="col.dataIndex === 'valueType'" class="input-wrapper">
                      <div class="ant-form-item-control" :class="{ 'has-error': errorOptions[scope.$index].valueType }"
                        style="">
                        <a-select class="w-100" :class="{ 'has-error': errorOptions[scope.$index].valueType }"
                          v-if="col.dataIndex === 'valueType'" :default-value="scope.row[col.dataIndex]"
                          @blur="validate('valueType', scope.row, scope.$index)"
                          @change="(value) => scope.row[col.dataIndex] = value">
                          <a-select-option value="UNSIGNED_SHORT">UNSIGNED_SHORT</a-select-option>
                          <a-select-option value="SIGNED_SHORT">SIGNED_SHORT</a-select-option>
                          <a-select-option value="UNSIGNED_INTEGER">UNSIGNED_INTEGER</a-select-option>
                          <a-select-option value="SIGNED_INTEGER">SIGNED_INTEGER</a-select-option>
                          <a-select-option value="FLOAT">FLOAT</a-select-option>
                        </a-select>
                        <div class="ant-form-explain" v-show="errorOptions[scope.$index].valueType">{{
                          $t('protocol.svt') }}</div>
                      </div>
                    </div>
                    <div v-else-if="col.dataIndex === 'pointType'" class="ant-form-item-control"
                      :class="{ 'has-error': errorOptions[scope.$index].pointType }" style="">
                      <a-select class="w-100" :class="{ 'has-error': errorOptions[scope.$index].pointType }"
                        :default-value="scope.row[col.dataIndex]" @blur="validate('pointType', scope.row, scope.$index)"
                        @change="(value) => scope.row[col.dataIndex] = value">
                        <a-select-option v-for="(v, k) in pointTypes" :key="k">{{ v }}</a-select-option>
                      </a-select>
                      <div class="ant-form-explain" v-show="errorOptions[scope.$index].pointType">{{ $t('protocol.spt')
                        }}</div>
                    </div>
                    <div v-else-if="col.dataIndex === 'byteOrder'" class="input-wrapper">
                      <div class="ant-form-item-control" :class="{ 'has-error': errorOptions[scope.$index].byteOrder }"
                        style="">
                        <a-select class="w-100" :class="{ 'has-error': errorOptions[scope.$index].byteOrder }"
                          :default-value="scope.row[col.dataIndex]"
                          @blur="validate('byteOrder', scope.row, scope.$index)"
                          @change="(value) => scope.row[col.dataIndex] = value">
                          <a-select-option value="LL_LH">LL_LH</a-select-option>
                          <a-select-option value="LH_LL">LH_LL</a-select-option>
                          <a-select-option value="LL_LH_HL_HH">LL_LH_HL_HH</a-select-option>
                          <a-select-option value="HH_HL_LH_LL">HH_HL_LH_LL</a-select-option>
                          <a-select-option value="LH_LL_HH_HL">LH_LL_HH_HL</a-select-option>
                          <a-select-option value="HL_HH_LL_LH">HL_HH_LL_LH</a-select-option>
                        </a-select>
                        <div class="ant-form-explain" v-show="errorOptions[scope.$index].byteOrder">{{
                          $t('protocol.sbo') }}</div>
                      </div>
                    </div>
                    <div v-else-if="col.dataIndex === 'dataWrite'" class="input-wrapper">
                      <div class="ant-form-item-control" :class="{ 'has-error': errorOptions[scope.$index].dataWrite }"
                        style="">
                        <a-select class="w-100" :class="{ 'has-error': errorOptions[scope.$index].dataWrite }"
                          :default-value="scope.row[col.dataIndex] !== undefined ? scope.row[col.dataIndex] : 0"
                          @blur="validate('dataWrite', scope.row, scope.$index)"
                          @change="(value) => scope.row[col.dataIndex] = value">
                          <a-select-option :value="0">{{ $t('protocol.readonly') }}</a-select-option>
                          <a-select-option :value="1">{{ $t('device.write') }}</a-select-option>
                          <a-select-option :value="2">{{ $t('warning.hide_o') }}</a-select-option>
                          <a-select-option :value="3">{{ $t('device.failure') }}</a-select-option>
                          <a-select-option :value="4">{{ $t('protocol.switch') }}</a-select-option>
                        </a-select>
                        <div class="ant-form-explain" v-show="errorOptions[scope.$index].dataWrite">{{
                          $t('protocol.saw') }}</div>
                      </div>
                    </div>
                    <template v-else-if="col.dataIndex === 'range'">
                      <div class="input-wrapper">
                        <div class="ant-form-item-control" style="width: 80px">
                          <span class="ant-form-item-children">
                            <input v-model="scope.row.range[0]" type="text" class="ant-input" style="">
                          </span>
                          <!-- <div class="ant-form-explain" v-show="errorOptions[scope.$index][col.dataIndex]">{{ errorOptions[scope.$index][col.dataIndex] }}</div> -->
                        </div>
                      </div>
                      -
                      <div class="input-wrapper">
                        <div class="ant-form-item-control" style="width: 80px">
                          <span class="ant-form-item-children">
                            <input v-model="scope.row.range[1]" type="text" class="ant-input" style="">
                          </span>
                          <!-- <div class="ant-form-explain" v-show="errorOptions[scope.$index][col.dataIndex]">{{ errorOptions[scope.$index][col.dataIndex] }}</div> -->
                        </div>
                      </div>
                    </template>
                    <div v-else-if="col.dataIndex === 'dataLevel'" class="input-wrapper">
                      <div class="ant-form-item-control" :class="{ 'has-error': errorOptions[scope.$index].dataLevel }"
                        style="">
                        <a-select class="w-100" :class="{ 'has-error': errorOptions[scope.$index].dataLevel }"
                          :default-value="scope.row[col.dataIndex] !== undefined ? scope.row[col.dataIndex] : 0"
                          @blur="validate('dataLevel', scope.row, scope.$index)"
                          @change="(value) => scope.row[col.dataIndex] = value">
                          <a-select-option :value="0">0</a-select-option>
                          <a-select-option :value="1">1</a-select-option>
                          <a-select-option :value="2">2</a-select-option>
                          <a-select-option :value="3">3</a-select-option>
                          <a-select-option :value="4">4</a-select-option>
                          <a-select-option :value="5">5</a-select-option>
                        </a-select>
                        <div class="ant-form-explain" v-show="errorOptions[scope.$index].dataLevel">{{
                          $t('protocol.sdl') }}</div>
                      </div>
                    </div>
                    <template v-else-if="col.dataIndex === 'read'">
                      <a-switch @change="changeRead(scope.row)" :defaultChecked="scope.row.read"
                        :checked-children="$t('protocol.open')" :un-checked-children="$t('protocol.close')" />
                    </template>
                    <template v-else-if="col.dataIndex === 'statusFlag'">
                      <a-switch @change="changeStatusFlag(scope.row)" :defaultChecked="scope.row.statusFlag === 1"
                        :checked-children="$t('protocol.open')" :un-checked-children="$t('protocol.close')" />
                    </template>
                    <!-- <a-input v-else-if="['en-US', 'unit'].includes(col.dataIndex)" class="w-100" v-model="scope.row[col.dataIndex]" @blur="f" /> -->
                    <div v-else-if="['en-US', 'unit'].includes(col.dataIndex)" class="input-wrapper">
                      <div class="ant-form-item-control" style="">
                        <span class="ant-form-item-children">
                          <input v-model="scope.row[col.dataIndex]" type="text" class="ant-input" style="">
                        </span>
                        <!-- <div class="ant-form-explain" v-show="errorOptions[scope.$index][col.dataIndex]">{{ errorOptions[scope.$index][col.dataIndex] }}</div> -->
                      </div>
                    </div>
                    <div v-else-if="col.dataIndex === 'code'" class="input-wrapper">
                      <div class="ant-form-item-control"
                        :class="{ 'has-error': errorOptions[scope.$index][col.dataIndex] }" style="">
                        <span class="ant-form-item-children">
                          <input v-model="scope.row[col.dataIndex]" @blur="validate('code', scope.row, scope.$index)"
                            type="text" class="ant-input" style="">
                        </span>
                        <div class="ant-form-explain" v-show="errorOptions[scope.$index][col.dataIndex]">{{
                          errorOptions[scope.$index][col.dataIndex] }}</div>
                      </div>
                    </div>
                    <div v-else class="input-wrapper">
                      <div class="ant-form-item-control"
                        :class="{ 'has-error': errorOptions[scope.$index][col.dataIndex] }" style="">
                        <span class="ant-form-item-children">
                          <input v-model="scope.row[col.dataIndex]"
                            @blur="validate(col.dataIndex, scope.row, scope.$index)" type="text" class="ant-input"
                            style="">
                        </span>
                        <div class="ant-form-explain" v-show="errorOptions[scope.$index][col.dataIndex]">{{
                          $t('protocol.e') }}{{ col[lang]
                          }}</div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <span v-if="col.dataIndex === 'range' && scope.row.range">
                      {{ scope.row.range[0] }} - {{ scope.row.range[1] }}
                    </span>
                    <span v-else-if="col.dataIndex === 'read'">{{ scope.row.read ? $t('common.open') :
                      $t('common.close') }}</span>
                    <span v-else-if="col.dataIndex === 'statusFlag'">{{ scope.row.statusFlag ? $t('common.open') :
                      $t('common.close') }}</span>
                    <span v-else-if="col.dataIndex === 'statisticType'">
                      {{ statistics[scope.row.statisticType] }}
                    </span>
                    <span v-else-if="col.dataIndex === 'dataWrite'">
                      {{ dataWrite[scope.row.dataWrite] }}
                    </span>
                    <span v-else-if="col.dataIndex === 'pointType'">
                      {{ pointTypes[scope.row.pointType] }}
                    </span>
                    <span v-else>
                      {{ scope.row[col.dataIndex] }}
                    </span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="450" fixed="right">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left; display: inline-flex">
                    {{ $t('common.operation') }}
                    <!-- <span class="icons unset" style="cursor: pointer;" data-index="0">
                      <a-icon type="caret-up" />
                      <a-icon type="caret-down" />
                    </span> -->
                  </div>
                </template>
                <template slot-scope="scope">
                  <a-space>
                    <a-button type="link" size="small" @click="editDataPoint(scope.row, scope.$index)">{{
                      scope.row.editable ? $t('buttons.save') : $t('buttons.edit') }}</a-button>
                    <a-button style="padding-left: 0;" type="link" size="small"
                      @click="removeDataPoint(scope.$index)">{{ $t('buttons.delete') }}</a-button>
                    <a-button style="padding-left: 0;" type="link" size="small"
                      @click="showConvertModal(scope.row, $t('protocol.convertRules'), 'statusMatchFormItems', 'statusMatch')">{{
                        $t('protocol.convertRules') }}</a-button>
                    <a-button style="padding-left: 0;" type="link" size="small"
                      @click="showConvertModal(scope.row, $t('device.bitRule'), 'bitFormItems', 'bitRules')">{{
                        $t('device.bitRule') }}</a-button>
                    <a-button style="padding-left: 0;" type="link" size="small"
                      @click="showConvertModal(scope.row, $t('device.valueRule'), 'rulesFormItems', 'valueRules')">{{
                        $t('device.valueRule') }}</a-button>
                    <a-button style="padding-left: 0;" type="link" size="small"
                      @click="showVirtualPointModal(scope.row)">{{ $t('protocol.virtualPointSetting') }}</a-button>
                  </a-space>
                </template>
              </el-table-column>
            </el-table>
            <!-- <a-pagination style="float: right; margin-top: 15px" :current="page" :pageSize="10" :total="total" @change="handlePageChange" /> -->
            <convert-modal :visible="convertModal.visible" :form="form" :title="title" v-model="convertModal.record"
              :field="field" @close="closeConvertModal" />
            <virtual-point-modal :points="protocolForm.points.filter(item => item.pointType !== 'NIL')"
              :visible="virtualPointModal.visible" v-model="virtualPointModal.record"
              @close="() => virtualPointModal.visible = false" />
          </div>
        </template>
        <template v-else>
          <div style="padding: 14px 20px;display: flex;justify-content: space-between;align-items: center">
            <div style="font-size: 18px;font-weight: bold">{{ $t('protocol.warningTemplate') }}</div>
            <a-space>
              <a-button @click="cancelT">{{ $t('common.cancelText') }}</a-button>
              <a-button type="primary" @click="confirm">{{ $t('common.okText') }}</a-button>
              <a-button type="primary" @click="addTemplate">{{ $t('protocol.addTemplate') }}</a-button>
            </a-space>
          </div>
          <div style="padding: 0 10px">
            <a-table row-key="id" :columns="warningColumns" :data-source="warningSearchResult"
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: selectRow }">
              <template v-slot:name="text">
                <text-highlight :queries="highLightInfo.name">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:noticeContent="text">
                <text-highlight :queries="highLightInfo.noticeContent">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:roleName="text">
                <text-highlight :queries="highLightInfo.roleName">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:noticeMobile="text">
                <text-highlight :queries="highLightInfo.noticeMobile">
                  {{ text }}
                </text-highlight>
              </template>
              <template v-slot:type="text">
                {{ warningTypeMap[text] }}
              </template>
              <template v-slot:dimension="text">
                {{ warningDimensionMap[text] }}
              </template>
              <template v-slot:operation="_, record">
                <div style="display: flex; justify-content: space-between; align-items: center">
                  <a-button style="padding-left: 0" type="link" @click="handleEdit(record)">{{ $t('buttons.edit')
                    }}</a-button>
                  <a-popconfirm :title="$t('messages.ctrd')" :ok-text="$t('common.okText')"
                    :cancel-text="$t('common.cancelText')" @confirm="delTemplate(record.id)">
                    <a-button style="padding-left: 0" type="link">{{ $t('buttons.delete') }}</a-button>
                  </a-popconfirm>
                </div>
              </template>
            </a-table>
          </div>
        </template>
      </div>
    </div>
    <div v-show="warning" style="background-color: #2F3D4F; width: 100%; min-height: 870px; position: relative"
      class="warning">
      <a-layout style="background-color: black">
        <a-layout>
          <div class="mask warning">
            <div style=" position: absolute; top: 5px; right: 10px; cursor: pointer;" @click="cancel">
              <a-icon type="close" style="color: #fff; font-size: 24px;" />
            </div>
            <a-spin size="large" class="spin" v-show="isLoading"></a-spin>
            <div v-show="!isLoading">
              <a-form-model layout="inline">
                <a-form-model-item :label="$t('warningForm.template')">
                  <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="model"
                    :placeholder="$t('warningForm.st')" dropdownClassName="selectOption" style="width: 280px"
                    @change="handleModelChange">
                    <a-select-option value="-">
                      {{ $t('warningForm.none') }}
                    </a-select-option>
                    <a-select-option v-for="warn in warningTemplateList" :key="warn.id" :value="warn.id">
                      {{ warn.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item>
                  <a-button style="margin-left: 10px" type="primary" v-show="isDelBtnShow" @click="delTemplate()">{{
                    $t('warningForm.delete') }}</a-button>
                </a-form-model-item>
              </a-form-model>
              <a-form-model layout="inline" :model="form1" :rules="rules" ref="form1">
                <a-form-model-item :label="$t('device.warningName')" style="margin-right: 60px;" prop="name">
                  <a-input v-model="form1.name" :placeholder="$t('warningForm.swmn')" style="width: 240px" />
                </a-form-model-item>
                <a-form-model-item :label="$t('device.warningType')" prop="dimension" style="margin-right: 60px;">
                  <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    :placeholder="$t('warning.swt')" v-model="form1.dimension" dropdownClassName="selectOption"
                    style="width: 200px">
                    <a-select-option value="DEVICE_STATUS">
                      {{ $t('warningForm.DEVICE_STATUS') }}
                    </a-select-option>
                    <a-select-option value="DEVICE_PARAMETER">
                      {{ $t('warningForm.DEVICE_PARAMETER') }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('warningForm.strategyConstraint')" prop="strategyConstraint"
                  style="margin-right: 60px;">
                  <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    :placeholder="$t('warningForm.sct')" v-model="form1.strategyConstraint"
                    dropdownClassName="selectOption" style="width: 200px">
                    <a-select-option value="AND">
                      {{ $t('warningForm.and') }}
                    </a-select-option>
                    <a-select-option value="OR">
                      {{ $t('warningForm.or') }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('menu.enabled')">
                  <a-switch v-model="form1.enabled" :checked-children="$t('common.yes')"
                    :un-checked-children="$t('common.no')" />
                </a-form-model-item>
              </a-form-model>
              <a-form-model :model="form2" ref="form2" :rules="rules">
                <a-form-model-item :label="$t('device.content')" prop="noticeContent">
                  <a-input v-model="form2.noticeContent" :placeholder="$t('warningForm.encn')"></a-input>
                </a-form-model-item>
              </a-form-model>
              <a-form-model class="flex" :model="form3" :rules="rules" ref="form3">
                <a-form-model-item :label="$t('warningForm.noticeFrequency')" prop="noticeFrequency">
                  <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="form3.noticeFrequency"
                    :placeholder="$t('warningForm.snf')" dropdownClassName="selectOption">
                    <a-select-option :value="1">
                      1
                    </a-select-option>
                    <a-select-option :value="3">
                      3
                    </a-select-option>
                    <a-select-option :value="6">
                      6
                    </a-select-option>
                    <a-select-option :value="12">
                      12
                    </a-select-option>
                    <a-select-option :value="24">
                      24
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('warningForm.warningLevel')" prop="warningLevel">
                  <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="form3.warningLevel"
                    :placeholder="$t('warningForm.swl')" dropdownClassName="selectOption">
                    <a-select-option value="URGENT">
                      {{ $t('warningForm.URGENT') }}
                    </a-select-option>
                    <a-select-option value="IMPORTANT">
                      {{ $t('warningForm.IMPORTANT') }}
                    </a-select-option>
                    <a-select-option value="MINOR">
                      {{ $t('warningForm.MINOR') }}
                    </a-select-option>
                    <a-select-option value="PROMPT">
                      {{ $t('warningForm.PROMPT') }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('warningForm.effectiveTime')" required>
                  <a-time-picker v-model="startTime" format="HH:mm" />
                  <span style="color: #fff; margin: 0 15px;">-</span>
                  <a-time-picker v-model="endTime" format="HH:mm" />
                </a-form-model-item>
              </a-form-model>
              <a-form-model class="flex" :model="form3">
                <a-form-model-item :label="$t('warningForm.noticeCnt')" required>
                  <a-input-number v-model="form3.noticeCnt" style="width: 80%;" />
                </a-form-model-item>
                <a-form-model-item :label="$t('warningForm.recoveryNotice')">
                  <a-switch v-model="form3.recoveryNotice" :checked-children="$t('common.yes')"
                    :un-checked-children="$t('common.no')" />
                </a-form-model-item>
                <div style="width: 96%;"></div>
              </a-form-model>
              <a-form-model :model="form4" :rules="rules" ref="form4">
                <a-form-model-item :label="$t('warningForm.warningRepeat')" prop="warningRepeat">
                  <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="form4.warningRepeat"
                    mode="tags" style="width: 100%; color: #fff" :placeholder="$t('warningForm.swr')"
                    dropdownClassName="selectOption">
                    <a-select-option value="1">{{ $t('warningForm.Sunday') }}</a-select-option>
                    <a-select-option value="2">{{ $t('warningForm.Monday') }}</a-select-option>
                    <a-select-option value="3">{{ $t('warningForm.Tuesday') }}</a-select-option>
                    <a-select-option value="4">{{ $t('warningForm.Wednesday') }}</a-select-option>
                    <a-select-option value="5">{{ $t('warningForm.Thursday') }}</a-select-option>
                    <a-select-option value="6">{{ $t('warningForm.Friday') }}</a-select-option>
                    <a-select-option value="7">{{ $t('warningForm.Saturday') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('warningForm.description')" prop="description">
                  <a-input :placeholder="$t('warningForm.ed')" v-model="form4.description"
                    style="padding: 0 10px; color: #fff" />
                </a-form-model-item>
                <div v-show="form1.dimension === 'DEVICE_PARAMETER'">
                  <h3 class="tableTitle">{{ $t('warningForm.judgeCondition') }}: </h3>
                  <a-button type="primary" @click="addFormTableItem">{{ $t('warningForm.addCondition') }}</a-button>
                  <a-button v-show="deviceTableList.dataList.length > 1" type="primary" icon="undo"
                    style="margin-left: 20px;" @click="undoData">{{ $t('warningForm.undo') }}</a-button>
                  <table class="formTable">
                    <thead>
                      <tr>
                        <th>{{ $t('configuration.parameter') }}</th>
                        <th>{{ $t('warningForm.judge') }}</th>
                        <th>{{ $t('warningForm.valueType') }}</th>
                        <th>{{ $t('warningForm.value') }}</th>
                        <th>{{ $t('warningForm.monitorTime') }}</th>
                        <th>{{ $t('warningForm.duration') }}</th>
                        <th>{{ $t('common.operation') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(dataTableItem, index) in deviceTableList.dataList" :key="dataTableItem.id">
                        <td style="position: relative; width: 16%;">
                          <a-input :placeholder="$t('param.selectParam')" readOnly
                            v-model="deviceTableList.dataList[index].dataName"
                            style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff"
                            @focus="handleFocus(index, 'dataList')" @blur="handleBlur(index, 'dataList')" />
                          <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                          <div
                            style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;"
                            v-show="deviceTableList.dataList[index].show">
                            <ul style="list-style: none; height: 300px; overflow: auto">
                              <li v-for="data in deviceDataList" :key="data.code" @mousedown="selectData(data, index)">
                                {{ data.name }}
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td style="position: relative; width: 16%;">
                          <a-input :placeholder="$t('warningForm.judge')" readOnly
                            v-model="deviceTableList.judgeList[index].value"
                            style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff"
                            @focus="handleFocus(index, 'judgeList')" @blur="handleBlur(index, 'judgeList')" />
                          <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                          <div
                            style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;"
                            v-show="deviceTableList.judgeList[index].show">
                            <ul style="list-style: none">
                              <li v-for="(key, judge) of judgeList" :key="key" @mousedown="selectJudge(index, judge)">
                                {{ judgeList[judge] }}
                                <!-- {{judgeList[judge]}} -->
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td style="position: relative; width: 16%;">
                          <a-input :placeholder="$t('warningForm.valueType')" readOnly
                            v-model="deviceTableList.valueTypeList[index].value"
                            style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff"
                            @focus="handleFocus(index, 'valueTypeList')" @blur="handleBlur(index, 'valueTypeList')" />
                          <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                          <div
                            style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;"
                            v-show="deviceTableList.valueTypeList[index].show">
                            <ul style="list-style: none">
                              <li v-for="(key, judge) of valueTypeList" :key="key"
                                @mousedown="selectValueType(index, judge)">
                                {{ valueTypeList[judge] }}
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td style="width: 16%;">
                          <a-input-number id="inputNumber" style="width: 96%; margin: 0 2%;"
                            v-model="deviceTableList.numberList[index].value" />
                        </td>
                        <td style="position: relative; width: 16%;">
                          <a-input :disabled="deviceTableList.valueTypeList[index].flag === 'ORIGIN'"
                            :placeholder="$t('warningForm.monitorTime')" readOnly
                            v-model="deviceTableList.duration[index].value"
                            style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff"
                            @focus="handleFocus(index, 'duration')" @blur="handleBlur(index, 'duration')" />
                          <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                          <div
                            style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;"
                            v-show="deviceTableList.duration[index].show">
                            <ul style="list-style: none">
                              <li v-for="(key, judge) of duration" :key="key" @mousedown="selectDuration(index, judge)">
                                {{ duration[judge] }}
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td style="position: relative; width: 16%;">
                          <a-input :disabled="deviceTableList.valueTypeList[index].flag === 'ORIGIN'"
                            :placeholder="$t('warningForm.duration')" readOnly
                            v-model="deviceTableList.period[index].value"
                            style="width: 96%; display: block; padding: 0 10px; margin: 0 auto; color: #fff"
                            @focus="handleFocus(index, 'period')" @blur="handleBlur(index, 'period')" />
                          <a-icon type="down" style="position: absolute; top: 12px; right: 16px" />
                          <div
                            style="position: absolute; top: 102%; width: 96%; background-color: #485464; color: #fff; z-index: 10; margin: 0 2%; text-align: left;"
                            v-show="deviceTableList.period[index].show">
                            <ul style="list-style: none">
                              <li v-for="judge in period" :key="judge" @mousedown="selectPeriod(index, judge)">
                                {{ judge }}
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td><a href="javascript:;" @click="removeFormTableItem(index)">{{ $t('buttons.delete') }}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <a-form-model-item :label="$t('warningForm.mobile')" :required="!isDelBtnShow">
                  <a-button type="primary" @click="addMobile">{{ $t('warningForm.addMobile') }}</a-button>
                  <table class="formTable">
                    <thead>
                      <tr>
                        <th>{{ $t('customer.realName') }}</th>
                        <th>{{ $t('warningForm.phoneNumber') }}</th>
                        <th>{{ $t('warningForm.userRole') }}</th>
                        <th>{{ $t('common.organization') }}</th>
                        <th>{{ $t('warningForm.SMSEnable') }}</th>
                        <th>{{ $t('warningForm.warningRecord') }}</th>
                        <th>{{ $t('common.operation') }}</th>
                      </tr>
                    </thead>
                    <tbody style="color: #ccc">
                      <tr v-for="(u, key) in userMap" :key="key">
                        <template v-if="u.editable">
                          <td><a-input @blur="f" style="width: 230px" v-model="u.realName" /></td>
                          <td><a-input :disabled="!!u.role" @blur="f" style="width: 230px" v-model="u.username" /></td>
                          <td><a-input :disabled="!!u.username" @blur="f" style="width: 230px" v-model="u.roleName" />
                          </td>
                          <td><a-input @blur="f" style="width: 230px" v-model="u.organizationName" /></td>
                        </template>
                        <template v-else>
                          <td>{{ u.realName }}</td>
                          <td>{{ u.username }}</td>
                          <td>{{ u.roleName }}</td>
                          <td>{{ u.organizationName }}</td>
                        </template>
                        <td>
                          <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')"
                            @change="f" v-model="u.checked" />
                        </td>
                        <td>
                          <a-switch :checked-children="$t('common.open')" :un-checked-children="$t('common.close')"
                            @change="f" v-model="u.queryEnabled" />
                        </td>
                        <td>
                          <a href="javascript:;" @click="editM(u)">{{ u.editable ? $t('buttons.save') :
                            $t('buttons.edit')
                            }}</a>
                          &nbsp;
                          &nbsp;
                          <span :class="{ disabled: length === 1 }" :disabled="length === 1" @click="removeU(u.id)">{{
                            $t('buttons.delete') }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </a-form-model-item>
              </a-form-model>
              <a-form-model>
                <a-form-model-item>
                  <a-button type="primary" @click="submitTemplate">{{ $t('warningForm.submitTemplate') }}</a-button>
                </a-form-model-item>
              </a-form-model>
            </div>
          </div>
        </a-layout>
      </a-layout>
    </div>
  </div>
</template>

<script>
// import { ModbusRTUProperty, ModbusRTUDataPoint } from '@/views/EquipmentManager/EquipmentProtocol/submit/modbus-rtu'
import { properties, ModbusRTUDataPoint, DLT6452007DataPoint, rulesFormItems, bitFormItems } from './protocolProperty'
import { addProtocol, getProtocol, updateProtocol } from '@/api/protocol'
// import { DLT6452007Property, DLT6452007DataPoint } from '@/views/EquipmentManager/EquipmentProtocol/submit/dlt645-2007'
import { protocolApi } from '@/api/station'
import { syncProtocol } from '@/api/protocol'
import ConvertModal from '@/views/EquipmentManager/EquipmentProtocol/components/ConvertModal'
import VirtualPointModal from '@/views/EquipmentManager/EquipmentProtocol/components/VirtualPointModal'
import { nanoid } from 'nanoid'
import { getWarningTemplateList, deleteWarningTemplate, addWarningTemplate, updateWarningTemplate } from '@/api/warning'
import { getDict } from '@/api/dict'
import moment, { lang } from 'moment'
import TextHighlight from 'vue-text-highlight'
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import * as XLSX from "@/plugins/export-excel"

export default {
  name: 'index',
  components: { ConvertModal, VirtualPointModal, TextHighlight },
  async mounted() {
    if (this.$route.query.code) {
      this.isEdit = true
      this.loading = true
      getProtocol(this.$route.query.code).then(({ data }) => {
        this.changeDriver(data.driver)
        data.points.forEach(p => {
          p.id = nanoid()
          p.details = p.details || []
          p['zh-CN'] = ''
          p['en-US'] = ''
          p.details.forEach(d => {
            p[d.locale] = d.name
          })
          if (!p['zh-CN']) {
            p['zh-CN'] = p.name
          }
          if (p.bitRules) {
            p.bitRules.forEach(b => {
              b.details = b.details || []
              b["name_zh-CN"] = ""
              b["name_en-US"] = ""
              b.details.forEach(d => {
                b[`name_${d.locale}`] = d.name
              })
              if (!b["name_zh-CN"]) {
                b["name_zh-CN"] = b.name
              }

              b.zeros = b.zeros || []
              b["zero_zh-CN"] = ""
              b["zero_en-US"] = ""
              b.zeros.forEach(d => {
                b[`zero_${d.locale}`] = d.value
              })
              if (!b["zero_zh-CN"]) {
                b["zero_zh-CN"] = b.zero
              }

              b.ones = b.ones || []
              b["one_zh-CN"] = ""
              b["one_en-US"] = ""
              b.ones.forEach(d => {
                b[`one_${d.locale}`] = d.value
              })
              if (!b["one_zh-CN"]) {
                b["one_zh-CN"] = b.one
              }
            })
          }

          if (p.valueRules) {
            p.valueRules.forEach(v => {
              v.details = v.details || []
              v["value_zh-CN"] = ""
              v["value_en-US"] = ""
              v.details.forEach(d => {
                v[`value_${d.locale}`] = d.value
              })
              if (!v["value_zh-CN"]) {
                v["value_zh-CN"] = v.value
              }
            })
          }
        })
        // this.total = data.points.length
        this.points = data.points
        this.protocolForm = data
        if (!data.warningTemplateId) {
          this.protocolForm.warningTemplateId = []
        } else {
          this.protocolForm.warningTemplateId = data.warningTemplateId.map(w => w + '')
        }
        this.selectedRowKeys = this.protocolForm.warningTemplateId.map(w => +w)
        this.errorOptions = data.points.map(() => ({}))
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.loading = false
      })


      // protocolApi.get(this.$route.query.driverType, this.$route.query.code).then(({ data }) => {
      //   this.changeDriver(data.driverType)
      //   this.protocolForm = data
      //   console.log(this.protocolForm.dataPoints)
      // }).catch(() => {
      //   // this.$message.error("请求失败")
      // })
      // console.log(this.driver)
    }
    this.getWarningTemplateList()
    this.getDict()
  },
  data() {
    return {
      warning: false,
      isLoading: false,
      en,
      zh,
      warningTemplateList: [],
      ModbusRTUDataPoint: [],
      queryParams: {},
      isEdit: false,
      driver: {
        protocolProperty: properties,
        dataPointColumns: []
      },
      loading: false,
      points: [],
      errorOptions: [],
      virtualPointModal: {
        visible: false,
        points: [],
        record: {}
      },
      queryParams: {

      },
      warningSearchResult: [],
      page: 1,
      total: 0,
      field: '',
      title: this.$t('device.bitRule'),
      statusMatchFormItems: [],
      rulesFormItems: [
        {
          span: 4,
          type: 'select',
          options: {
            'EQ': '=',
            'NE': '≠',
            'LT': '<',
            'LE': '≤',
            'GT': '>',
            'GE': '≥'
          },
          dataIndex: 'match',
          placeholder: this.$t('protocol.sm')
        },
        {
          span: 5,
          type: 'text',
          dataIndex: 'targetValue',
          placeholder: this.$t('protocol.etv')
        },
        {
          span: 5,
          type: 'text',
          dataIndex: 'value',
          placeholder: this.$t('protocol.esv')
        },
        {
          span: 8,
          type: 'text',
          placeholder: this.$t('protocol.et'),
          dataIndex: 'tag'
        }
      ],
      bitFormItems: [
        {
          span: 5,
          type: 'text',
          placeholder: this.$t('protocol.ep'),
          dataIndex: 'pos'
        },
        {
          span: 5,
          type: 'text',
          placeholder: this.$t('protocol.en'),
          dataIndex: 'name'
        },
        {
          span: 3,
          type: 'text',
          placeholder: '0',
          dataIndex: 'zero'
        },
        {
          span: 3,
          type: 'text',
          placeholder: '1',
          dataIndex: 'one'
        },
        {
          span: 8,
          type: 'text',
          placeholder: this.$t('protocol.et'),
          dataIndex: 'tag'
        }
      ],
      form: [],
      protocolForm: {
        code: '',
        name: '',
        type: '',
        driver: '',
        intervalTime: undefined,
        timeout: undefined,
        retryCnt: undefined,
        remark: '',
        points: [],
        pointLimit: '',
        warningTemplateId: []
      },
      rules: {
        driver: [
          {
            message: this.$t('messages.pedd'),
            required: true,
            trigger: 'blur'
          }
        ],
        code: [
          {
            message: this.$t('messages.pedp'),
            required: true,
            trigger: 'blur'
          },
          {
            message: this.$t('protocol.dcs'),
            trigger: 'blur',
            pattern: /^[a-zA-Z0-9]+$/
          }
        ],
        name: [
          {
            message: this.$t('protocol.epn'),
            required: true,
            trigger: 'blur'
          }
        ],
        type: [
          {
            message: this.$t('protocol.selectProtocolType'),
            required: true,
            trigger: 'blur'
          }
        ],
        intervalTime: [
          {
            message: this.$t('protocol.ei'),
            required: true,
            trigger: 'blur'
          }
        ],
        // pointLimit: [
        //   {
        //     message: '请输入单次请求最大数据点',
        //     required: true,
        //     trigger: 'blur'
        //   }
        // ],
        timeout: [
          {
            message: this.$t('protocol.eto'),
            required: true,
            trigger: 'blur'
          }
        ],
        retryCnt: [
          {
            message: this.$t('protocol.erc'),
            required: true,
            trigger: 'blur'
          }
        ],
      },
      protocolFormSpan: 6,
      convertModal: {
        visible: false,
        record: {}
      },
      valueType: {
        UNSIGNED_SHORT: 'UNSIGNED_SHORT',
        SIGNED_SHORT: 'SIGNED_SHORT',
        UNSIGNED_INTEGER: 'UNSIGNED_INTEGER',
        SIGNED_INTEGER: 'SIGNED_INTEGER',
        FLOAT: 'FLOAT'
      },
      analyticMethod: ['LL_LH', 'LH_LL', 'LL_LH_HL_HH', 'HH_HL_LH_LL', 'LH_LL_HH_HL', 'HL_HH_LL_LH'],
      statistics: [this.$t('protocol.sum'), this.$t('protocol.fluctuation')],
      dataWrite: [],
      pointTypes: {
        'NIL': this.$t('common.none'),
        'RO': this.$t('protocol.readonly'),
        'WO': this.$t('protocol.wirteOnly'),
        'RW': this.$t('protocol.war')
      },
      authorities: [],
      form1: {
        name: '',
        dimension: undefined,
        strategyConstraint: undefined,
        enabled: false
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t('protocol.epn'),
            trigger: 'blur'
          },
          {
            max: 20,
            message: this.$t('protocol.nlt20'),
            trigger: 'blur'
          }
        ],
        dimension: [
          {
            required: true,
            message: this.$t('warning.swt')
          }
        ],
        strategyConstraint: [
          {
            required: true,
            message: this.$t('warningForm.sct')
          }
        ],
        noticeContent: [
          {
            required: true,
            message: this.$t('warningForm.enc'),
            trigger: 'blur'
          },
          {
            max: 120,
            message: this.$t('protocol.nlt120'),
            trigger: 'blur'
          }
        ],
        noticeFrequency: [
          {
            required: true,
            message: this.$t('warningForm.snf')
          }
        ],
        warningLevel: [
          {
            required: true,
            message: this.$t('warningForm.swl')
          }
        ],
        warningRepeat: [
          {
            required: true,
            message: this.$t('warningForm.swr')
          }
        ],
      },
      form2: {
        noticeContent: ''
      },
      form3: {
        noticeFrequency: undefined,
        warningLevel: undefined,
        noticeCnt: 3,
        recoveryNotice: true
      },
      form4: {
        description: '',
        warningRepeat: undefined
      },
      model: undefined,
      startTime: moment('00:00', 'HH:mm'),
      endTime: moment('00:00', 'HH:mm'),
      deviceTableList: {
        dataList: [{ id: nanoid(), dataName: '', show: false, code: '', warningId: undefined }],
        judgeList: [{ value: '', show: false, flag: undefined }],
        valueTypeList: [{ value: '', show: false, flag: undefined }],
        numberList: [{ value: 0 }],
        duration: [{ value: '', show: false, flag: undefined }],
        period: [{ value: '', show: false, flag: undefined }]
      },
      deviceDataList: [],
      judgeList: {
        EQ: '=',
        NE: '≠',
        GT: '>',
        GE: '≥',
        LT: '<',
        LE: '≤'
      },
      valueTypeList: {
        AVERAGE: this.$t('warningForm.AVERAGE'),
        MAX: this.$t('warningForm.MAX'),
        MIN: this.$t('warningForm.MIN'),
        SUM: this.$t('warningForm.SUM'),
        ORIGIN: this.$t('warningForm.ORIGIN')
      },
      duration: {
        5: '5' + this.$t('warningForm.minutes'),
        20: '20' + this.$t('warningForm.minutes'),
        60: '60' + this.$t('warningForm.minutes')
      },
      period: [1, 2, 3, 4, 5],
      userMap: {},
      length: 0,
      isPointsShow: true,
      params: {
        name: '',
        type: '',
        dimension: '',
        noticeContent: '',
        roleName: '',
        noticeMobile: ''
      },
      highLightInfo: {
        name: '',
        noticeContent: '',
        roleName: '',
        noticeMobile: ''
      },
      warningTypes: [
        {
          key: '',
          zh: '全部',
          en: 'All'
        },
        {
          key: 'STATION',
          zh: '站房',
          en: 'Station'
        },
        {
          key: 'DEVICE',
          zh: '设备',
          en: 'Device'
        }
      ],
      warningDimensions: [
        {
          key: '',
          zh: '全部',
          en: 'All'
        },
        {
          key: 'DEVICE_STATUS',
          zh: '离线预警',
          en: 'Off-line Warning'
        },
        {
          key: 'DEVICE_PARAMETER',
          zh: '参数预警',
          en: 'Parameter Warning'
        },
        {
          key: 'STATION',
          zh: '站房预警',
          en: 'Station Warning'
        }
      ],
      warningColumns: [
        {
          title: () => this.$t('warningForm.templateId'),
          key: 'id',
          dataIndex: 'id'
        },
        {
          title: () => (
            <div>
              {this.$t('dataReport.templateName')}
              <a-input v-model={this.params.name} onKeyup={(e) => e.key === 'Enter' && this.searchWarningTemplate()} />
            </div>
          ),
          key: 'name',
          dataIndex: 'name',
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          title: () => (
            <div>
              {this.$t('device.warningType')}
              <a-select style="width: 100%" v-model={this.params.type} onChange={this.searchWarningTemplate}>
                {
                  this.warningTypes.map(t => (
                    <a-select-option value={t.key}>
                      {t[this.lang]}
                    </a-select-option>
                  ))
                }
              </a-select>
            </div>
          ),
          key: 'type',
          dataIndex: 'type',
          scopedSlots: {
            customRender: 'type'
          }
        },
        {
          title: () => (
            <div>
              {this.$t('device.warningDimension')}
              <a-select style="width: 100%" v-model={this.params.dimension} onChange={this.searchWarningTemplate}>
                {
                  this.warningDimensions.map(t => (
                    <a-select-option value={t.key}>
                      {t[this.lang]}
                    </a-select-option>
                  ))
                }
              </a-select>
            </div>
          ),
          key: 'dimension',
          dataIndex: 'dimension',
          scopedSlots: {
            customRender: 'dimension'
          }
        },
        {
          title: () => (
            <div>
              {this.$t('warningForm.content')}
              <a-input v-model={this.params.noticeContent} onKeyup={(e) => e.key === 'Enter' && this.searchWarningTemplate()} />
            </div>
          ),
          key: 'noticeContent',
          dataIndex: 'noticeContent',
          scopedSlots: {
            customRender: 'noticeContent'
          }
        },
        {
          title: () => (
            <div>
              {this.$t('warningForm.userRole')}
              <a-input v-model={this.params.roleName} onKeyup={(e) => e.key === 'Enter' && this.searchWarningTemplate()} />
            </div>
          ),
          key: 'roleName',
          dataIndex: 'roleName',
          width: 200,
          scopedSlots: {
            customRender: 'roleName'
          }
        },
        {
          title: () => (
            <div>
              {this.$t('device.mobile')}
              <a-input v-model={this.params.noticeMobile} onKeyup={(e) => e.key === 'Enter' && this.searchWarningTemplate()} />
            </div>
          ),
          key: 'noticeMobile',
          dataIndex: 'noticeMobile',
          width: 250,
          scopedSlots: {
            customRender: 'noticeMobile'
          }
        },
        {
          title: () => this.$t('common.operation'),
          key: 'operation',
          dataIndex: 'operation',
          scopedSlots: {
            customRender: 'operation'
          },
          width: 100
        }
      ],
      selectedRowKeys: []
    }
  },
  computed: {
    isDelBtnShow() {
      return this.model !== '-' && this.model !== undefined
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.translate(v)
      }
    }
  },
  created() {
    this.authorities = JSON.parse(sessionStorage.getItem('authorities'))
  },
  methods: {
    translate(v) {
      locale.use(this[v])
      this.statusMatchFormItems = [
        {
          span: 6,
          type: 'select',
          options: {
            'EQ': '=',
            'NE': '≠',
            'LT': '<',
            'LE': '≤',
            'GT': '>',
            'GE': '≥'
          },
          dataIndex: 'match',
          placeholder: this.$t('protocol.sm')
        },
        {
          span: 5,
          type: 'text',
          dataIndex: 'targetValue',
          placeholder: this.$t('protocol.etv')
        },
        {
          span: 4,
          type: 'text',
          dataIndex: 'value',
          placeholder: this.$t('protocol.match')
        },
        {
          span: 6,
          type: 'text',
          placeholder: this.$t('protocol.et'),
          dataIndex: 'tag'
        }
      ]
      this.rulesFormItems = [
        {
          span: 4,
          type: 'select',
          options: {
            'EQ': '=',
            'NE': '≠',
            'LT': '<',
            'LE': '≤',
            'GT': '>',
            'GE': '≥'
          },
          dataIndex: 'match',
          placeholder: this.$t('protocol.sm')
        },
        {
          span: 3,
          type: 'text',
          dataIndex: 'targetValue',
          placeholder: this.$t('protocol.etv')
        },
        {
          span: 4,
          type: 'text',
          dataIndex: 'value_zh-CN',
          placeholder: this.$t('protocol.value_zh')
        },
        {
          span: 4,
          type: 'text',
          dataIndex: 'value_en-US',
          placeholder: this.$t('protocol.value_en')
        },
        {
          span: 6,
          type: 'text',
          placeholder: this.$t('protocol.et'),
          dataIndex: 'tag'
        }
      ]
      this.bitFormItems = [
        {
          span: 3,
          type: 'text',
          placeholder: this.$t('protocol.ep'),
          dataIndex: 'pos'
        },
        {
          span: 3,
          type: "text",
          placeholder: this.$t("protocol.name_zh"),
          dataIndex: "name_zh-CN"
        },
        {
          span: 3,
          type: "text",
          placeholder: this.$t("protocol.name_en"),
          dataIndex: "name_en-US"
        },
        {
          span: 2,
          type: "text",
          placeholder: this.$t("protocol.zero_zh"),
          dataIndex: "zero_zh-CN"
        },
        {
          span: 2,
          type: "text",
          placeholder: this.$t("protocol.zero_en"),
          dataIndex: "zero_en-US"
        },
        {
          span: 2,
          type: "text",
          placeholder: this.$t("protocol.one_zh"),
          dataIndex: "one_zh-CN"
        },
        {
          span: 2,
          type: "text",
          placeholder: this.$t("protocol.one_en"),
          dataIndex: "one_en-US"
        },
        {
          span: 5,
          type: 'text',
          placeholder: this.$t('protocol.et'),
          dataIndex: 'tag'
        }
      ]
      this.rules = {
        name: [
          {
            required: true,
            message: this.$t('protocol.epn'),
            trigger: 'blur'
          },
          {
            max: 20,
            message: this.$t('protocol.nlt20'),
            trigger: 'blur'
          }
        ],
        dimension: [
          {
            required: true,
            message: this.$t('warning.swt')
          }
        ],
        strategyConstraint: [
          {
            required: true,
            message: this.$t('warningForm.sct')
          }
        ],
        noticeContent: [
          {
            required: true,
            message: this.$t('warningForm.enc'),
            trigger: 'blur'
          },
          {
            max: 120,
            message: this.$t('protocol.nlt120'),
            trigger: 'blur'
          }
        ],
        noticeFrequency: [
          {
            required: true,
            message: this.$t('warningForm.snf')
          }
        ],
        warningLevel: [
          {
            required: true,
            message: this.$t('warningForm.swl')
          }
        ],
        warningRepeat: [
          {
            required: true,
            message: this.$t('warningForm.swr')
          }
        ],
      }
      this.valueType = {
        UNSIGNED_SHORT: 'UNSIGNED_SHORT',
        SIGNED_SHORT: 'SIGNED_SHORT',
        UNSIGNED_INTEGER: 'UNSIGNED_INTEGER',
        SIGNED_INTEGER: 'SIGNED_INTEGER',
        FLOAT: 'FLOAT'
      }
      this.analyticMethod = ['LL_LH', 'LH_LL', 'LL_LH_HL_HH', 'HH_HL_LH_LL', 'LH_LL_HH_HL', 'HL_HH_LL_LH']
      this.statistics = [this.$t('protocol.sum'), this.$t('protocol.fluctuation')],
        this.dataWrite = [this.$t('protocol.readonly'), this.$t('protocol.wirte'), this.$t('warning.hide_o'), this.$t('device.failure'), this.$t('protocol.switch')],
        this.pointTypes = {
          'NIL': this.$t('common.none'),
          'RO': this.$t('protocol.readonly'),
          'WO': this.$t('protocol.wirteOnly'),
          'RW': this.$t('protocol.war')
        }
      this.valueTypeList = {
        AVERAGE: this.$t('warningForm.AVERAGE'),
        MAX: this.$t('warningForm.MAX'),
        MIN: this.$t('warningForm.MIN'),
        SUM: this.$t('warningForm.SUM'),
        ORIGIN: this.$t('warningForm.ORIGIN')
      }
      this.duration = {
        5: '5' + this.$t('warningForm.minutes'),
        20: '20' + this.$t('warningForm.minutes'),
        60: '60' + this.$t('warningForm.minutes')
      }
      this.warningTypeMap = {}
      this.warningDimensionMap = {}
      this.warningTypes.forEach(w => {
        this.warningTypeMap[w.key] = w[this.lang]
      })
      this.warningDimensions.forEach(w => {
        this.warningDimensionMap[w.key] = w[this.lang]
      })
    },
    changeDriver(value) {
      switch (value) {
        case 'MODBUS_RTU':
          this.rules.pointLimit = [
            {
              message: this.$t('protocol.epl'),
              required: true,
              trigger: 'blur'
            }
          ]
          this.protocolForm.driver = 'MODBUS_RTU'
          this.driver.dataPointColumns = ModbusRTUDataPoint
          break
        case 'DLT645_2007':
          delete this.rules.pointLimit
          this.protocolForm.driver = 'DLT645_2007'
          this.driver.dataPointColumns = DLT6452007DataPoint
          break
        default:
          this.driver.protocolProperty = []
          this.driver.dataPointColumns = []
      }
    },
    editDataPoint(_, i) {
      let points = [...this.points]
      const record = points[i]
      record.edited = true
      if (!record.editable) {
        record.range = record.range || ['', '']
      }
      if (record.editable) {
        const f = this.validateRecords(record, i, false)
        if (f) {
          return this.$message.error(this.$t('protocol.cpi'))
        }
      }
      record.editable = !record.editable
      this.points = points
      this.$forceUpdate()
    },
    handlePageChange(page) {
      this.page = page
      this.points = this.protocolForm.points.slice((page - 1) * 10, page * 10)
    },
    validateRecords(r, i, reset) {
      let fs = []
      fs.push(this.validate('code', r, i, reset))
      fs.push(this.validate('zh-CN', r, i, reset))
      fs.push(this.validate('codecType', r, i, reset))
      fs.push(this.validate('statisticType', r, i, reset))
      fs.push(this.validate('valueType', r, i, reset))
      fs.push(this.validate('pointType', r, i, reset))
      fs.push(this.validate('startAddress', r, i, reset))
      fs.push(this.validate('registerCnt', r, i, reset))
      fs.push(this.validate('coefficient', r, i, reset))
      fs.push(this.validate('byteOrder', r, i, reset))
      fs.push(this.validate('dataWrite', r, i, reset))
      fs.push(this.validate('dataLevel', r, i, reset))
      fs.push(this.validate('priority', r, i, reset))
      fs.push(this.validate('dataMark', r, i, reset))
      console.log(fs);
      return fs.some(f => !f)
    },
    removeDataPoint(i) {
      let index = this.protocolForm.points.findIndex(item => item.id === this.points[i].id)
      this.protocolForm.points.splice(index, 1)
      this.protocolForm.points !== this.points && this.points.splice(i, 1)
    },
    addDataPoints() {
      let item = {
        id: nanoid(),
        edited: true,
        editable: true,
      }
      this.errorOptions.push({})
      this.points !== this.protocolForm.points && this.points.push(item)
      this.protocolForm.points.push(item)
      let c = this.protocolForm.driver === 'MODBUS_RTU' ? ModbusRTUDataPoint : DLT6452007DataPoint
      c.forEach(dataPoint => {
        item[dataPoint.dataIndex] = ''
      })
      item.statisticType = "0"
      item.pointType = "RO"
      item.dataWrite = 0
      item.dataLevel = 5
      if (this.protocolForm.driver === 'MODBUS_RTU') {
        item.readControlCode = "03"
        item.writeControlCode = "06"
        item.codecType = "HEX"
      }
      item.range = ['', '']
      item.statusMatch = []
      item.read = true
      item.bitRules = null
      item.valueRules = null
      item.statusFlag = 0
      this.$forceUpdate()
    },
    addProtocol() {
      this.$refs.pForm.validate(valid => {
        if (valid) {
          this.protocolForm.pointLimit = this.protocolForm.pointLimit ? +this.protocolForm.pointLimit : ''
          let fs = []
          for (let i = 0; i < this.protocolForm.points.length; i++) {
            const r = this.protocolForm.points[i]
            if (!r.edited) {
              continue
            }
            fs.push(this.validateRecords(r, i, true))
          }
          if (fs.some(f => f)) {
            return this.$message.error(this.$t('protocol.cpi'))
          }
          this.protocolForm.intervalTime = +this.protocolForm.intervalTime
          this.protocolForm.points.forEach(point => {
            point.startAddress = +point.startAddress
            point.registerCnt = +point.registerCnt
            point.statisticType = +point.statisticType
            point.priority = +point.priority
            if (point.range === '') {
              point.range = null
            }
            point.details = [
              {
                name: point['zh-CN'],
                locale: 'zh-CN'
              },
              {
                name: point['en-US'],
                locale: 'en-US'
              }
            ]
            point.name = point['zh-CN']
            if (point.bitRules) {
              const bitRules = []
              point.bitRules.forEach(b => {
                const details = [
                  {
                    locale: "zh-CN",
                    name: b["name_zh-CN"] || ""
                  },
                  {
                    locale: "en-US",
                    name: b["name_en-US"] || ""
                  }
                ]

                const zeros = [
                  {
                    locale: 'zh-CN',
                    value: b["zero_zh-CN"] || ""
                  },
                  {
                    locale: "en-US",
                    value: b["zero_en-US"] || ""
                  }
                ]

                const ones = [
                  {
                    locale: "zh-CN",
                    value: b["one_zh-CN"] || ""
                  },
                  {
                    locale: "en-US",
                    value: b["one_en-US"] || ""
                  }
                ]

                b.details = details
                b.zeros = zeros
                b.ones = ones
                console.log(zeros)

                if (b.pos || b.pos === 0) {
                  bitRules.push(b)
                }
              })
              point.bitRules = bitRules
            }

            if (point.valueRules) {
              const valueRules = []
              point.valueRules.forEach(v => {
                const details = [
                  {
                    locale: "zh-CN",
                    value: v["value_zh-CN"] || ""
                  },
                  {
                    locale: "en-US",
                    value: v["value_en-US"] || ""
                  }
                ]
                v.details = details
                if (v.targetValue) {
                  valueRules.push(v)
                }
              })
              point.valueRules = valueRules
            }
          })
          if (this.isEdit) {
            updateProtocol(this.protocolForm).then(({ message }) => {
              this.$message.success(message)
              this.refresh()
              this.$router.back()
            }).catch(() => {
              // this.$message.error("请求失败")
            })
          } else {
            addProtocol(this.protocolForm).then(({ message }) => {
              this.$message.success(message)
              this.$router.back()
            }).catch(() => {
              // this.$message.error("请求失败")
            })
          }
        }
      })
    },
    validate(c, r, i, reset) {
      let ii = i
      if (!reset) {
        ii = this.protocolForm.points.findIndex(p => p.id === this.points[i].id)
      }
      const errorOptions = [...this.errorOptions]
      let f = true
      if (this.protocolForm.driver === 'MODBUS_RTU' && c === 'dataMark') {
        return true
      }
      if (this.protocolForm.driver === 'DLT645_2007' && ['valueType', 'startAddress', 'registerCnt', 'byteOrder'].includes(c)) {
        return true
      }
      if (c === 'code') {
        const pattern = /^[a-zA-Z0-9_]+$/
        if (r.code === '') {
          errorOptions[i].code = this.$t('protocol.ec')
          f = false
        } else if (!pattern.test(r.code)) {
          errorOptions[i].code = this.$t('protocol.dcs')
          f = false
        } else {
          let p
          for (let index = 0; index < this.protocolForm.points.length; index++) {
            if (index === ii) {
              continue
            }
            if (this.protocolForm.points[index].code === r.code) {
              p = this.protocolForm.points[index]
            }
          }
          if (p) {
            errorOptions[i].code = this.$t('protocol.cr')
            f = false
          } else {
            errorOptions[i].code = false
            f = true
          }
        }
      } else {
        if (typeof r[c] === 'number' || (typeof r[c] === 'string' && r[c])) {
          errorOptions[i][c] = false
          f = true
        } else {
          errorOptions[i][c] = true
          f = false
        }
      }
      this.errorOptions = errorOptions
      this.$forceUpdate()
      return f
    },
    f() {
      this.$forceUpdate()
    },
    searchPoints() {
      this.loading = true
      const r = []
      let p
      for (let i = 0; i < this.protocolForm.points.length; i++) {
        p = this.protocolForm.points[i]
        let flag = true
        for (let key in this.queryParams) {
          this.queryParams[key] = this.queryParams[key].trim()
          if (this.queryParams[key]) {
            if (!String(p[key]).toLowerCase()?.includes(this.queryParams[key].toLowerCase())) {
              flag = false
              break
            }
          }
        }

        flag && r.push(p)
        flag = true
      }
      this.points = r
      this.loading = false
    },
    change(val) {
      if (val === 'protocolCode') {
        protocolApi.exist(this.protocolForm.protocolCode).then(({ data }) => {
          if (data) {
            this.$message.error(this.$t('protocol.pce'))
          }
        }).catch(() => {
          // this.$message.error("请求失败")
        })
      }
    },
    goBack() {
      this.$store.commit('setProtocolFlag', true)
      this.$router.back()
    },
    changeRead(record) {
      record.read = !record.read
    },
    changeStatusFlag(record) {
      record.statusFlag = record.statusFlag === 0 ? 1 : 0
    },
    showConvertModal(record, title, form, field) {
      this.field = field
      record[field] = record[field] || []
      this.convertModal.record = record
      this.title = title
      console.log(form)
      this.form = this[form]
      this.convertModal.visible = true
    },
    closeConvertModal() {
      this.convertModal.visible = false
    },
    async refresh() {
      try {
        const { message } = await syncProtocol(this.$route.query.code)
        this.$message.success(message)
      } catch {
        this.$message.error(this.$t('protocol.pce'))
      }
    },
    showVirtualPointModal(record) {
      if (record.pointType !== 'NIL') {
        this.$message.warning(this.$t('protocol.virtualPoint'))
        return
      }
      this.virtualPointModal.record = record
      this.virtualPointModal.visible = true
    },
    cancel() {
      for (let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].resetFields()
      }
      this.mobiles = [
        {
          mobile: '',
          name: '',
          smsEnabled: true,
          warningId: null,
          error: false
        }
      ]
      this.form4.description = ''
      this.form1.enabled = false
      this.form4.warningRepeat = undefined
      this.id = undefined
      this.isAddOrEdit = false
      this.model = undefined
      this.deviceTableList = {
        dataList: [{ id: nanoid(), dataName: '', show: false, code: '', warningId: undefined }],
        judgeList: [{ value: '', show: false, flag: undefined }],
        valueTypeList: [{ value: '', show: false, flag: undefined }],
        numberList: [{ value: '' }],
        duration: [{ value: '', show: false, flag: undefined }],
        period: [{ value: '', show: false, flag: undefined }]
      }
      this.isLoading = false
      this.warning = false
      this.model = undefined
    },
    handleModelChange(value) {
      if (value !== '-') {
        this.model = value
        const warning = this.warningTemplateList.find(warn => warn.id === value)
        for (let i = 1; i < 5; i++) {
          for (let key in this[`form${i}`]) {
            this[`form${i}`][key] = warning[key]
          }
        }
        const time = warning.effectiveTime.split('-')
        this.startTime = moment(time[0], 'HH:mm')
        this.endTime = moment(time[1], 'HH:mm')
        this.userMap = {}
        if (warning.mobiles) {
          warning.mobiles.forEach(m => {
            const id = nanoid()
            m.id = id
            m.checked = m.smsEnabled
            this.userMap[id] = m
          })
        }
        this.form4.warningRepeat = warning.warningRepeat.split(',')
        if (warning.strategy && warning.strategy.length > 0) {
          if (warning.strategy?.[0].name === '离线指标') {
            return
          }
          const deviceTableList = {
            dataList: [],
            judgeList: [],
            numberList: [],
            valueTypeList: [],
            duration: [],
            period: []
          }
          warning.strategy.forEach(strategie => {
            deviceTableList.dataList.push({
              id: strategie.id,
              dataName: strategie.name,
              code: strategie.code,
              show: false
            })
            deviceTableList.judgeList.push({
              value: this.judgeList[strategie.condition],
              flag: strategie.condition,
              show: false
            })
            deviceTableList.numberList.push({
              value: strategie.targetValue
            })
            deviceTableList.valueTypeList.push({
              value: this.valueTypeList[strategie.valueType],
              flag: strategie.valueType,
              show: false
            })
            deviceTableList.duration.push({
              value: this.duration[strategie.duration],
              flag: strategie.duration,
              show: false
            })
            deviceTableList.period.push({
              value: this.period[strategie.period - 1],
              flag: strategie.period,
              show: false
            })
          })
          this.deviceTableList = deviceTableList
        }
      } else {
        for (let i = 1; i < 5; i++) {
          this.$refs[`form${i}`].resetFields()
        }
        this.mobiles = [
          {
            mobile: '',
            name: '',
            smsEnabled: true,
            warningId: null,
            error: false
          }
        ]
        this.form4.description = ''
        this.form1.enabled = false
        this.form4.warningRepeat = undefined
        this.id = undefined
        this.model = undefined
        this.deviceTableList = {
          dataList: [{ id: nanoid(), dataName: '', show: false, code: '', warningId: undefined }],
          judgeList: [{ value: '', show: false, flag: undefined }],
          valueTypeList: [{ value: '', show: false, flag: undefined }],
          numberList: [{ value: '' }],
          duration: [{ value: '', show: false, flag: undefined }],
          period: [{ value: '', show: false, flag: undefined }]
        }
      }
    },
    async delTemplate(id = this.model) {
      try {
        console.log(id);
        const { message } = await deleteWarningTemplate(id)
        this.$message.success(message)
        this.getWarningTemplateList()
        for (let i = 1; i < 5; i++) {
          this.$refs[`form${i}`].resetFields()
        }
        this.mobiles = [
          {
            mobile: '',
            name: '',
            smsEnabled: true,
            warningId: null,
            error: false
          }
        ]
        this.form4.description = ''
        this.form1.enabled = false
        this.form4.warningRepeat = undefined
        this.id = undefined
        this.model = undefined
        const index = this.selectedRowKeys.findIndex(s => s == id)
        if (index > -1) {
          this.selectedRowKeys.splice(index, 1)
          this.protocolForm.warningTemplateId = this.selectedRowKeys.map(s => s + '')
        }
      } catch (err) {
        console.error(err)
      }
    },
    addFormTableItem() {
      this.deviceTableList.dataList.push({
        id: nanoid(),
        dataName: '',
        show: false
      })
      this.deviceTableList.judgeList.push({
        value: '',
        show: false
      })
      this.deviceTableList.valueTypeList.push({
        value: '',
        show: false
      })
      this.deviceTableList.duration.push({
        value: '',
        show: false
      })
      this.deviceTableList.period.push({
        value: '',
        show: false
      })
      this.deviceTableList.numberList.push({
        value: 0
      })
    },
    undoData() {
      let flag = false
      for (let key in this.deviceTableList) {
        const value = this.deviceTableList[key].at(-1).value || this.deviceTableList[key].at(-1).code
        if (value) {
          flag = true
          this.deviceTableList[key].at(-1).value = ''
          if (this.deviceTableList[key].at(-1).code) {
            this.deviceTableList[key].at(-1).code = ''
            this.deviceTableList[key].at(-1).dataName = ''
          }
        }
      }
      if (!flag) {
        for (let key in this.deviceTableList) {
          this.deviceTableList[key].pop()
        }
      }
    },
    addMobile() {
      const id = nanoid()
      this.userMap[id] = {
        checked: false,
        id,
        organizationName: '',
        realName: '',
        role: '',
        username: '',
        editable: true
      }
      this.$forceUpdate()
    },
    async submitTemplate() {
      let formValid = false
      for (let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].validate(valid => {
          if (valid) {
            formValid = true
          }
        })
      }
      const effectiveTime = moment(+this.startTime).format('HH:mm') + '-' + moment(+this.endTime).format('HH:mm')
      const warningRepeat = this.form4.warningRepeat.join(',')
      const strategy = []
      if (this.form1.dimension === 'DEVICE_PARAMETER') {
        this.deviceTableList.dataList.forEach((data, index) => {
          const param = {
            name: data.dataName,
            code: data.code,
            valueType: this.deviceTableList.valueTypeList[index].flag,
            condition: this.deviceTableList.judgeList[index].flag,
            targetValue: this.deviceTableList.numberList[index].value + '',
            duration: this.deviceTableList.duration[index].flag,
            period: this.deviceTableList.period[index].flag
          }
          if (typeof data.id === 'number') {
            param.id = data.id
          }
          strategy.push(param)
        })
      }
      if (this.form1.dimension === 'DEVICE_STATUS') {
        strategy[0] = {
          name: '离线指标',
          code: 'offline',
          valueType: 'ORIGIN',
          condition: 'EQ',
          targetValue: '3',
          duration: 20,
          period: 5
        }
      }
      if (formValid) {
        const mobiles = []
        for (let key in this.userMap) {
          const k = this.userMap[key]
          console.log(k);
          if (k.checked || k.queryEnabled) {
            mobiles.push({
              smsEnabled: !!k.checked,
              organizationName: this.userMap[key].organizationName || '',
              mobile: this.userMap[key].username || '',
              name: this.userMap[key].realName || '',
              roleName: k.roleName,
              queryEnabled: !!k.queryEnabled
            })
          }
          console.log(mobiles);
        }
        const params = {
          name: this.form1.name,
          description: this.form4.description,
          type: 'DEVICE',
          dimension: this.form1.dimension,
          targetType: '',
          sort: 1,
          strategyConstraint: this.form1.strategyConstraint,
          noticeContent: this.form2.noticeContent,
          noticeFrequency: this.form3.noticeFrequency,
          warningLevel: this.form3.warningLevel,
          noticeCnt: this.form3.noticeCnt,
          recoveryNotice: this.form3.recoveryNotice,
          warningRepeat,
          effectiveTime,
          enabled: this.form1.enabled,
          strategy,
          mobiles
        }
        try {
          if (typeof this.model === 'number') {
            params.id = this.model
            const { message } = await updateWarningTemplate(params)
            this.$message.success(message)
          } else {
            const i = this.warningTemplateList.find(item => item.name === this.form1.name)
            if (i) {
              return this.$message.warn(this.$t('warningForm.exitedTemplate'))
            }
            const { message } = await addWarningTemplate(params)
            this.$message.success(message)
          }
          this.getWarningTemplateList()
        } catch (err) {
          console.error(err)
        }
      }
    },
    editM(u) {
      u.editable = !u.editable
      this.$forceUpdate()
    },
    async getDict() {
      const { data } = await getDict('zh-CN', 'deviceType')
      this.deviceTypeMap = {}
      data.content.forEach(c => {
        this.deviceTypeMap[c.value] = c.text
      })
    },
    handleFocus(index, type) {
      this.deviceTableList[type][index].show = true
    },
    handleBlur(index, type) {
      this.deviceTableList[type][index].show = false
    },
    selectData(data, index) {
      this.deviceTableList.dataList[index].dataName = data.name
      this.deviceTableList.dataList[index].code = data.code
    },
    selectJudge(index, judge) {
      this.deviceTableList.judgeList[index].value = this.judgeList[judge]
      this.deviceTableList.judgeList[index].flag = judge
    },
    selectValueType(index, type) {
      this.deviceTableList.valueTypeList[index].value = this.valueTypeList[type]
      this.deviceTableList.valueTypeList[index].flag = type
      this.$forceUpdate()
    },
    selectDuration(index, type) {
      this.deviceTableList.duration[index].value = this.duration[type]
      this.deviceTableList.duration[index].flag = type
    },
    selectPeriod(index, type) {
      this.deviceTableList.period[index].value = type
      this.deviceTableList.period[index].flag = type
    },
    addTemplate() {
      this.warning = true
    },
    searchWarningTemplate() {
      this.warningSearchResult = this.warningTemplateList.filter(w => {
        let f = true
        for (let k in this.params) {
          f = f && ((w[k] || '').includes(this.params[k]))
        }
        return f
      })
      for (let k in this.highLightInfo) {
        this.highLightInfo[k] = this.params[k]
      }
    },
    async getWarningTemplateList() {
      try {
        const { data } = await getWarningTemplateList('')
        this.warningSearchResult = this.warningTemplateList = data.map(d => {
          if (d.mobiles?.length) {
            d.roleName = []
            d.noticeMobile = []
            d.mobiles.forEach(m => {
              d.roleName.push(m.roleName)
              d.noticeMobile.push(m.mobile)
            })
            d.roleName = d.roleName.join(', ')
            d.noticeMobile = d.noticeMobile.join(', ')
          }
          return d
        })
      } catch (e) {
        console.log(e)
      } finally {

      }
    },
    selectRow(rows) {
      this.selectedRowKeys = rows
    },
    confirm() {
      this.protocolForm.warningTemplateId = this.selectedRowKeys.map(s => s + '')
      this.isPointsShow = true
    },
    handleEdit(r) {
      this.warning = true
      this.handleModelChange(r.id)
    },
    cancelT() {
      this.selectedRowKeys = []
      this.isPointsShow = true
    },
    removeFormTableItem(index) {
      for (const key in this.deviceTableList) {
        this.deviceTableList[key].splice(index, 1)
      }
    },
    exportProtocolToExcel() {
      const data = { ...this.protocolForm, points: this.points }
      const isDLT645 = data.driver === "DLT645_2007"

      const wb = XLSX.utils.book_new()

      const wsData = []
      
      /* 第一行：协议信息表头 */
      let headers = [
        "驱动类型", // A
        "协议编码", // B
        "协议名称", // C
        "协议类型(public/private)", // D
        "采集间隔(s)(10,30,60,180,300,600)",  // E
        "单次请求最大数据点", // F
        "采集超时(s)",  // G
        "重连次数", // H
        "备注", // I
        "参数标志", // J
        "预警模板", // K
        "", // L
        "", // M
        "", // N
        "", // O
        "", // P
        "", // Q
        "", // R
        ""  // S
      ]
      if (!isDLT645) {
        headers = headers.concat(
          [
            "", // T
            "", // U,
            ""  // V
          ]
        )
      }
      wsData.push(headers)

      /* 第二行：协议基本信息 */
      let protocolInfoRow = [
        data.driver, // A
        data.code, // B
        data.name, // C
        data.type, // D
        data.intervalTime,  // E
        data.pointLimit, // F
        data.timeout,  // G
        data.retryCnt, // H
        data.remark || "", // I
        data.ignoreCode || "", // J
        (data.warningTemplateId || "") + "", // K
        "", // L
        "", // M
        "", // N
        "", // O
        "", // P
        "", // Q
        "", // R
        ""  // S
      ]
      if (!isDLT645) {
        protocolInfoRow = protocolInfoRow.concat(
          [
            "", // T
            "", // U,
            ""  // V
          ]
        )
      }
      wsData.push(protocolInfoRow)

      /* 第三到五行：空行 */
      for (let i = 0; i < 3; i++) {
        wsData.push(
          isDLT645
            ? new Array(18).fill("")
            : new Array(21).fill("")
        )
      }

      /* 第六行：数据点表头 */
      const pointHeaders = {
        DLT645_2007: [
          "编码", // A
          "名称(中)", // B
          "名称(英)", // C
          "单位", // D
          "编码形式(HEX/BCD)", // E
          "统计类型(0波动量/1累积量)", // F
          "读写模式(RO只读, WO只写, RW读写, NIL无)", // G
          "数据标识", // H
          "系数", // I
          "数据写入(0只读, 1写入, 2保养, 3故障, 4开关)", // J
          "上下限", // K
          "数据等级", // L
          "排序", // M
          "开启监控(0关闭,1开启)", // N
          "转换规则(EQ, NE, GT, GE, LT, LE)\r\nEQ-目标值-显示值", // O
          "位解析\r\n位号-名称-0-1", // P
          "值解析(EQ, NE, GT, GE, LT, LE)\r\nEQ-目标值-显示值", // Q
          "虚拟数据点配置", // R
        ],
        MODBUS_RTU: [
          "编码", // A
          "名称(中)", // B
          "名称(英)", // C
          "单位", // D
          "编码形式(HEX/BCD)", // E
          "统计类型(0波动量/1累积量)", // F
          "数据类型(UNSIGNED_SHORT, SIGNED_SHORT, UNSIGNED_INTEGER, SIGNED_INTEGER, FLOAT)", // G
          "读写模式(RO只读, WO只写, RW读写, NIL无)", // H
          "开始地址", // I
          "数据长度", // J
          "系数", // K
          "解析方式(LH_LL, LL_LH, HH_HL_LH_LL, LH_LL_HH_HL, LL_LH_HL_HH, HL_HH_LL_LH)", // L
          "数据写入(0只读, 1写入, 2保养, 3故障, 4开关)", // M
          "上下限", // N
          "数据等级", // O
          "排序", // P
          "开启监控(0关闭,1开启)", // Q
          "转换规则(EQ, NE, GT, GE, LT, LE)\r\nEQ-目标值-显示值", // R
          "位解析\r\n位号-名称-0-1", // S
          "值解析(EQ, NE, GT, GE, LT, LE)\r\nEQ-目标值-显示值", // T
          "虚拟数据点配置" // U
        ]
      }
      wsData.push(pointHeaders[data.driver])

      /* 第七行起：数据点信息 */
      let j, p, d, chineseName, englishName, statusMatchStr, bitRulesStr, valueRulesStr, rangeStr, monitorFlagStr, pointRow
      for (let i = 0; i < data.points.length; i++) {
        chineseName = ""
        englishName = ""
        p = data.points[i]

        p.details = p.details || []
        for (j = 0; j < p.details.length; j++) {
          d = p.details[j]
          if (d.locale === "zh-CN") {
            chineseName = d.name
          }
          if (d.locale === "en-US") {
            englishName = d.name
          }
        }

        statusMatchStr = p.statusMatch?.map(s => `${s.match}-${s.targetValue}-${s.value}`).join("@") || ""

        bitRulesStr = p.bitRules?.map(b => `${b.pos}-${b.name}-${b.zero}-${b.one}`).join("@") || ""

        valueRulesStr = p.valueRules?.map(v => `${v.match}-${v.targetValue}-${v.value}`).join("@") || ""

        rangeStr = p.range?.length === 2 ? p.range.join("-") : ""

        monitorFlagStr = p.read ? 1 : 0

        wsData.push(
          isDLT645
            ? [
                p.code, // A
                chineseName, // B
                englishName, // C
                p.unit, // D
                p.codecType, // E
                p.statisticType, // F
                p.pointType, // G
                p.dataMark, // H
                p.coefficient, // I
                p.dataWrite, // J
                rangeStr, // K
                p.dataLevel, // L
                p.priority, // M
                monitorFlagStr, // N
                statusMatchStr, // O
                bitRulesStr, // P
                valueRulesStr, // Q
                p.expression // R
              ]
            : [
                p.code, // A
                chineseName, // B
                englishName, // C
                p.unit, // D
                p.codecType, // E
                p.statisticType, // F
                p.valueType, // G
                p.pointType, // H
                p.startAddress, // I
                p.registerCnt, // J
                p.coefficient, // K
                p.byteOrder, // L
                p.dataWrite, // M
                rangeStr, // N
                p.dataLevel, // O
                p.priority, // P
                monitorFlagStr, // Q
                statusMatchStr, // R
                bitRulesStr, // S
                valueRulesStr, // T
                p.expression // U
              ]
        )
      }

      // 工作表
      const ws = XLSX.utils.aoa_to_sheet(wsData)
      const colWidths = {
        DLT645_2007: [
          { wch: 15 },  // A: 驱动类型
          { wch: 15 },  // B: 协议编码
          { wch: 12 },  // C: 协议名称
          { wch: 20 },  // D: 协议类型
          { wch: 35 },  // E: 采集间隔
          { wch: 15 },  // F: 单次请求最大数据点
          { wch: 12 },  // G: 采集超时
          { wch: 10 },  // H: 重连次数
          { wch: 10 },  // I: 备注
          { wch: 10 },  // J: 参数标志
          { wch: 10 },  // K: 预警模板
          { wch: 10 },  // L: 空
          { wch: 10 },  // M: 空
          { wch: 10 },  // N: 空
          { wch: 10 },  // O: 空
          { wch: 10 },  // P: 空
          { wch: 10 },  // R: 空
          { wch: 15 }   // R: 虚拟数据点配置
        ],
        MODBUS_RTU: [
          { wch: 15 },  // A
          { wch: 15 },  // B
          { wch: 12 },  // C
          { wch: 20 },  // D
          { wch: 35 },  // E
          { wch: 15 },  // F
          { wch: 12 },  // G
          { wch: 10 },  // H
          { wch: 10 },  // I
          { wch: 10 },  // J
          { wch: 10 },  // K
          { wch: 10 },  // L
          { wch: 10 },  // M
          { wch: 10 },  // N
          { wch: 10 },  // O
          { wch: 10 },  // P
          { wch: 10 },  // Q
          { wch: 40 },  // R
          { wch: 30 },  // S
          { wch: 40 },  // T
          { wch: 15 }   // U
        ]
      }
      ws["!cols"] = colWidths[data.driver]

      XLSX.utils.book_append_sheet(wb, ws, "Sheet1")

      const fileName = data.code + " - " + data.name + ".xlsx"
      XLSX.writeFile(wb, fileName)
    }
  }
}
</script>

<style scoped lang="less">
.row {
  margin-top: 5px;
}

.ant-table-column-title div {
  position: relative;
}

.ant-table-column-title span {
  position: relative;
}

.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}

.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}

.ant-table-column-title span.icons {
  position: absolute;
}

.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}

.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}

span {
  position: relative;
}

.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}

span.ASC .anticon-caret-up {
  color: #1890ff;
}

span.DESC .anticon-caret-down {
  color: #1890ff;
}

.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}

/deep/ .ant-table-tbody .ant-table-row:nth-child(2n) {
  background: rgb(250, 250, 250);
}

div {
  position: relative;
}

span {
  position: relative;
}

.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}

span.ASC .anticon-caret-up {
  color: #1890ff;
}

span.icons {
  position: absolute;
  right: 18px;
}

span.DESC .anticon-caret-down {
  color: #1890ff;
}

.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}

/deep/ .el-table .caret-wrapper {
  display: unset;
  position: absolute;
  top: -5px;
  right: 3px;
}

/deep/ .el-table__empty-text {
  position: fixed;
  right: 45%;
  transform: translateX(50%);
}

.ant-layout-has-sider {
  margin: 20px;
}

.stationName {
  height: auto;
  background-color: #001529;
  margin: 0;
  padding: 0;
  color: #fff;
  line-height: 40px;
  font-size: 22px;
  padding-left: 24px;
}

.warning {
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /deep/ .ant-btn {
    padding: 0 10px;
  }

  position: relative;
  background-color: #2F3D4F;
  height: auto;

  &.ant-layout-content {
    min-height: 860px !important;
  }

  ul {
    width: 100%;

    li {
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
    }

    li:hover {
      background-color: #A7ADB5;
    }
  }

  form {
    width: 90%;
    margin: 20px auto;

    h3.tableTitle {
      font-size: 15px;
      color: #bfbfbf;
      margin-bottom: 15px;
    }

    input.ant-input {
      color: #fff;
      padding: 0 10px;
    }
  }

  .spin {
    position: absolute;
    top: 300px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }

  .header {
    width: 95%;
    margin: auto;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    color: #F8FCED;
    border-bottom: 1px solid #1976CF;
  }

  table {
    width: 100%;
    border: 1px solid #4A5665;
    color: #A7ADB5;
    margin-top: 24px;
    margin-bottom: 24px;

    th,
    td {
      height: 60px;
      text-align: center;
    }

    th {
      border-right: 1px solid #5B6574;
      background-color: #485464;
      padding: 0 10px;
    }

    td {
      border-top: 1px solid #445161;
      border-right: 1px solid #445161;

      &.content {
        width: 300px;
        overflow: hidden;
        box-sizing: border-box;

        span {
          display: block;
          max-width: 280px;
          padding-left: 10px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .formTable th,
  .formTable td {
    height: 40px;
  }

  .flex {
    display: flex;
    justify-content: space-between;

    .ant-form-item {
      width: 30%
    }
  }
}

.warning .ant-input,
.warning .ant-select-selection__placeholder.ant-input,
.warning .ant-calendar-picker-input.ant-input {
  background-color: #2F3D4F;
}

.warning .ant-input[data-v-020d5318],
.warning .ant-select-selection__placeholder.ant-input[data-v-020d5318],
.warning .ant-calendar-picker-input.ant-input[data-v-020d5318] {
  padding: 0 10px;
  color: #fff;
}

.ant-menu-item {
  padding-left: 30px !important;
}

.ant-menu-sub.ant-menu-inline>.ant-menu-item {
  height: auto;
  display: flex;
  align-items: center;
}

.ant-menu-sub.ant-menu-inline>.ant-menu-item span {
  white-space: normal;
  word-break: break-all;
  flex: 1;
}

.ant-menu-sub.ant-menu-inline>.ant-menu-item span.more {
  line-height: 20px;
}

.ant-col .wrapper {
  display: flex;
  justify-content: space-between;

  div {
    width: 30%;

    label {
      color: #bfbfbf;
    }
  }
}

.formTable span:not(.disabled) {
  color: #1890ff;
  cursor: pointer;
}

span.disabled {
  color: #999;
  cursor: not-allowed !important;
}
</style>
